export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    validate: Function,
    initial: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      lastCorrect: this.value,
      min: 5,
      max: 94, // coz 99 - 5
      invalid: false,
      val: 0,
      focused: false,
    };
  },
  computed: {
    valueWithCent() {
      return this.focused ? this.val : `${this.val}¢`;
    },
  },
  created() {
    this.val = this.value;
  },
  methods: {
    updateValue(value) {
      if (value === '') {
        return;
      }

      const parsed = Number.parseInt(value, 10);
      if (Number.isNaN(parsed)) {
        this.$refs.input.value = this.lastCorrect;
        return;
      }

      if (`${parsed}` !== value) {
        this.$refs.input.value = this.lastCorrect;
        return;
      }

      if (value > this.max) {
        this.lastCorrect = this.max;
        this.$refs.input.value = this.max;
        return;
      }

      this.lastCorrect = parsed;
    },
    onFocus() {
      this.focused = true;
    },
    onBlur() {
      this.focused = false;
      this.val = this.lastCorrect;

      if (this.$refs.input.value === '') {
        this.val = this.min;
      }
      if (this.lastCorrect < this.min) {
        this.val = this.min;
      }

      if (this.lastCorrect > this.max) {
        this.val = this.max;
      }

      this.$refs.input.value = `${this.val}¢`;
      this.$emit('input', this.val);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/forms/currency-input/currency-input.js